
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { FeatherIconsComponent } from '../../shared/components/feather-icons/feather-icons.component';
import { HOME_ROUTE } from '../../shared/constants/constants';
import { AuthService } from '../../shared/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { StorageService } from '../../shared/services/storage.service';
import { NavService } from '../../shared/services/nav.service';

@Component({
  selector: 'app-login',
  imports: [
    RouterModule,
    ReactiveFormsModule,
    FeatherIconsComponent,
    TranslateModule
],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  public show: boolean = false;
  public loginForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private authService: AuthService,
    private navService: NavService
  ) {
    const userData = localStorage.getItem('user');
    if (userData?.length != null) {
      router.navigate([HOME_ROUTE]);
    }

    this.loginForm = this.fb.group({
      email: ['super@admin.com', [Validators.required, Validators.email]],
      password: ['secret', Validators.required],
      rememberMe: [false]
    });
  }

  showPassword() {
    this.show = !this.show;
  }

  login() {
    const { email, password, rememberMe } = this.loginForm.value;
    let payload = { email, password, rememberMe };
    this.authService.login(payload).subscribe({
      next: (data: any) => {
        let user = data.user;
        if (rememberMe) {
          localStorage.setItem('user', JSON.stringify(user));
        } else {
          sessionStorage.setItem('user', JSON.stringify(user));
        }
        // Refresh menu items based on user role
        this.navService.refreshMenuItems();
        this.router.navigate([HOME_ROUTE]);
      },
      error: (error) => {
        console.error('Error on login', error);
      },
      complete: () => {}
    });
  }
}
